import { render, staticRenderFns } from "./VoucherClipboard.vue?vue&type=template&id=1bf29833&"
import script from "./VoucherClipboard.vue?vue&type=script&lang=js&"
export * from "./VoucherClipboard.vue?vue&type=script&lang=js&"
import style0 from "./VoucherClipboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports